import {NgModule} from '@angular/core';
import {Routes, RouterModule, PreloadAllModules} from '@angular/router';

import {Page500Component} from 'src/app/modules/shared/components/error-pages/page500/page500.component';
import {Page404Component} from 'src/app/modules/shared/components/error-pages/page404/page404.component';

const routes: Routes = [
    {
        path: '',
        loadChildren: './modules/auth/auth.module#AuthModule'
    },
    {
        path: 'dashboard',
        loadChildren: './modules/dashboard/dashboard.module#DashboardModule'
    },
    {
        path: 'master',
        loadChildren: './modules/master/master.module#MasterModule'
    },
    {
        path: 'wizard',
        loadChildren: './modules/wizard/wizard.module#WizardModule'
    },
    {
        path: 'pricing',
        loadChildren: './modules/pricing/pricing.module#PricingModule'
    },
    {
        path: 'meals',
        loadChildren: './modules/meals/meals.module#MealsModule'
    },
    {
        path: 'survey',
        loadChildren: './modules/survey/survey.module#SurveyModule'
    },
    {
        path: 'settings',
        loadChildren: './modules/settings/settings.module#SettingsModule'
    },
    {
        path: 'faq',
        loadChildren: './modules/faq/faq.module#FAQModule'
    },
    {
        path: 'sport',
        loadChildren: './modules/sport/sport.module#SportModule'
    },
    {
        path: 'verify',
        loadChildren: './modules/verify/verify.module#VerifyModule'
    },
    {
        path: 'news',
        loadChildren: './modules/news/news.module#NewsModule'
    },
    {
        path: 'user-preferred-products',
        loadChildren: './modules/user-preferred-products/user-preferred-products.module#UserPreferredProductsModule'
    },
    {
        path: 'user-preferred-global-categories',
        loadChildren: './modules/user-preferred-global-categories/user-preferred-global-categories.module#UserPreferredGlobalCategoriesModule'
    },
    {
        path: 'stars',
        loadChildren: './modules/stars/stars.module#StarsModule'
    },
    {
        path: 'misc',
        loadChildren: './modules/misc/misc.module#MiscModule'
    },
    {
        path: 'referrals',
        loadChildren: './modules/referrals/referrals.module#ReferralsModule'
    },
    {
        path: 'wallet',
        loadChildren: './modules/wallet/wallet.module#WalletModule'
    },
    {
        path: 'videos',
        loadChildren: './modules/videos/videos.module#VideosModule'
    },
    {
        path: 'recipes',
        loadChildren: './modules/recipes/recipes.module#RecipesModule'
    },
    {
        path: 'invoices',
        loadChildren: './modules/invoices/invoices.module#InvoicesModule'
    },
    {
        path: 'error-404',
        component: Page404Component
    },
    {
        path: 'error-500',
        component: Page500Component,
    },
    {
        path: '**',
        redirectTo: '/error-404'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        anchorScrolling: 'enabled',
        preloadingStrategy: PreloadAllModules
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
